module.exports = __webpack_public_path__ + "img/5.c0e7b57b.jpg";